import CryptoJS from 'crypto-js';
const keys = '4EAA9A2E37924186B86A72CE6F3A746E';//'DZM44mScObYjpsHL';
export default {
    //AES加密
    encrypt(word, keyStr) {
        keyStr = keyStr ? keyStr : keys; //判断是否存在key，不存在就用定义好的key
        var b = CryptoJS.enc.Base64; //需要base64加密的
        var key = CryptoJS.enc.Utf8.parse(keyStr.substring(0,16));
        var iv = CryptoJS.enc.Utf8.parse(keyStr.substring(16));
        var srcs = CryptoJS.enc.Utf8.parse(word);
        var encrypted = CryptoJS.AES.encrypt(srcs, key, {iv: iv,  mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
        //return encrypted.toString();
        return b.stringify(encrypted.ciphertext);
    },
    //AES解密
    decrypt(word, keyStr) {
        keyStr = keyStr ? keyStr : keys;
        var key = CryptoJS.enc.Utf8.parse(keyStr.substring(0,16));
        var iv = CryptoJS.enc.Utf8.parse(keyStr.substring(16));
        var decrypt = CryptoJS.AES.decrypt(word, key, {iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
        return CryptoJS.enc.Utf8.stringify(decrypt).toString();
    },
    HmacSHA256(word,keyStr){
        keyStr = keyStr ? keyStr : keys;
        var b = CryptoJS.enc.Base64; //需要base64加密的
        var key = CryptoJS.enc.Utf8.parse(keyStr);
        var srcs = CryptoJS.enc.Utf8.parse(word);
        var encrypted = CryptoJS.HmacSHA256(srcs,key);
        return b.stringify(encrypted);
    }
}    